import { Map, List, fromJS } from 'immutable'
import _set from 'lodash/set'
import _get from 'lodash/get'
import _parseInt from 'lodash/parseInt'
import _isUndefined from 'lodash/isUndefined'
import _toNumber from 'lodash/toNumber'
import _max from 'lodash/max'
import { v4 as uuidv4 } from 'uuid'
import { getAuthIsLoggedIn, DEVICE } from 'services/auth'
import { emarsysSend } from 'services/emarsys'
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import {
  getGoogleRecaptchaScript,
  getCaptchaVerifyToken,
  CAPTCHA_ACTION_BILLING_PAYMENT_FORM_VIEW,
} from 'services/captcha'
import { fromCallback as fromCallbackPromise } from 'bluebird'
import { SET_RESOLVER_DATA } from 'services/resolver/actions'
import { SET_APP_BOOTSTRAP_PHASE } from 'services/app/actions'
import { get as getCookie } from 'cookies-js'
import {
  SET_EVENT_CART_CHECKOUT_STEP,
  setEventStartMembershipClicked,
  setCartAbandonEmailDataLayer,
  CREATE_SERVER_EVENT,
  SET_EVENT_SIGN_UP,
  SET_EVENT_BEGIN_CHECKOUT,
  SET_EVENT_PURCHASE,
  SET_EVENT_PURCHASED_PLAN,
  SET_EVENT_LEAD,
} from 'services/event-tracking/actions'
import { PAYMENT_PROVIDER_NAME_ZUORA } from 'services/paytrack'
import { SET_PAYTRACK_DATA_LAST_TRANSACTION } from 'services/paytrack/actions'
import { SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS_WITH_DETAILS } from 'services/user-account/actions'
import { userCreate } from 'services/user'
import {
  SET_USER_DATA_ENTITLED,
  SET_USER_PROCESSING,
  SET_USER_DATA,
  SET_USER_CREATE_PROCESSING,
  SET_USER_CREATE_DATA,
  SET_USER_CREATE_CAPTCHA_VALID,
  getUserEmailAvailability,
} from 'services/user/actions'
import { removeInterstitial } from 'services/interstitial/actions'
import {
  setPlansLocalizedSelection,
  SET_PLANS_DATA,
  SET_PLANS_SELECTION,
} from 'services/plans/actions'
import { NAVIGATION_HISTORY_PUSH } from 'services/navigation/actions'
import { checkVelocity, getVelocityCheckActionLocation } from 'services/velocity-check'
import {
  updateAdyenAuthorization,
  ADYEN_PAYMENT_RESPONSE_CODE_AUTHORIZED,
} from 'services/adyen'
import {
  SET_PAYMENT_DATA,
} from 'services/payment/actions'
import {
  SET_VELOCITY_CHECK_PROCESSING,
  SET_VELOCITY_CHECK_DATA,
} from 'services/velocity-check/actions'
import {
  doAuthLogin,
  doAuthRenew,
  SET_AUTH_LOGIN_SUCCESS,
  SET_AUTH_LOGIN_FAILED,
} from 'services/auth/actions'
import { setFeatureTrackingDataPersistent } from 'services/feature-tracking/actions'
import { setMessageBoxVisible } from 'components/MessageBox/actions'
import {
  buildCheckoutStepDataLayerObject,
  buildEmailDataLayerObject,
  SERVER_EVENT_PURCHASE,
  FACEBOOK_EVENT_NAME_PURCHASE,
  FACEBOOK_EVENT_ACTION_SOURCE,
  buildSignUpObject,
  buildBeginCheckoutObject,
  buildPurchaseObject,
  buildPurchasedPlanObject,
} from 'services/event-tracking'
import { setContentImpression } from 'services/content-impressions'
import { requestAnimationFrame } from 'services/animate'
import {
  format as formatDateTime,
  getUnixTimestamp,
} from 'services/date-time'
import {
  ACCOUNT_TYPE_FMTV_GIFT,
  ACCOUNT_TYPE_FMTV_COMP,
  ACCOUNT_TYPE_ZUORA_GIFT,
} from 'services/user-account'
import {
  planIsGift,
  PLAN_ID_LIVE,
} from 'services/plans'
import {
  getUserEntitled,
  isEntitled,
} from 'services/subscription'
import { EN } from 'services/languages/constants'
import {
  CHECKOUT_STEP_ONE,
  CHECKOUT_STEP_TWO,
  CHECKOUT_STEP_THREE,
  CHECKOUT_EVENT_STEP_ONE,
  CHECKOUT_EVENT_STEP_TWO,
  CHECKOUT_EVENT_STEP_THREE,
  CHECKOUT_EVENT_STEP_FOUR,
  CHECKOUT_EVENT_STEP_FIVE,
  CHECKOUT_EVENT_STEP_SIX,
  CHECKOUT_EVENT_STEP_SEVEN,
  PAYMENT_TYPE_PAYPAL,
  CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN,
  CHECKOUT_ASYNC_DELAY_MILLISECONDS,
  CHECKOUT_ASYNC_MAX_ATTEMPTS,
  userCheckoutAllowed,
  getCheckoutOrderData,
} from 'services/checkout'
import {
  isCart,
  isPlans,
  isCartAccessDenied,
  isGo,
  isLogout,
  isCartConfirmation,
  isGetStarted,
  isGift as isGiftPage,
} from 'services/url'
import {
  URL_PLAN_SELECTION,
  URL_PLAN_SELECTION_PLANS,
  URL_ACCOUNT_CREATION,
  URL_CART_ACCOUNT_CREATION_CREATE,
  URL_CART_BILLING,
  URL_CART_BILLING_PAYMENT,
  URL_CART_CONFIRMATION,
  URL_CART_ACCESS_DENIED,
  URL_HOME,
  URL_GAIA_PROD,
} from 'services/url/constants'
import {
  SET_DIALOG_COMPONENT_NAME,
  SET_DIALOG_OPTIONS,
  renderModal,
} from 'services/dialog/actions'
import { GIFT_SUBSCRIPTION_STATE } from 'services/gift'
import { TYPE_LOGIN, TYPE_CART_ABANDON } from 'services/dialog'
import { scrollToTop } from 'services/dom'
import { LTM, USD } from 'services/currency'
import { getPrimary } from 'services/languages'
import { addNewRelicAction } from 'services/app/_newrelic'
import { get as getConfig } from 'config'
import { postBrooklyn as postEmailCapture } from 'services/email-signup'
import * as actions from './actions'

const dateFormatString = 'YYYY-MM-DD'

const config = getConfig()
const MEMBERSHIP_BUTTON_CLICKED = 'start membership button clicked'
const fingerprintJsApiKey = _get(config, 'fingerPrintJsApiKey')
const fingerprintJsSubdomain = _get(config, 'fingerPrintJsSubdomain')
const velocityCheckActive = !!_get(config, ['features', 'checkout', 'velocityCheck'])

function isCheckoutPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    isCart(path) || isPlans(path)
  )
}

function isCartAccessDeniedPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    isCartAccessDenied(path)
  )
}

function isAuthenticatedCheckout ({ state }) {
  const { resolver, auth } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    (isPlans(path)
    || path === URL_ACCOUNT_CREATION
    || path === URL_CART_ACCOUNT_CREATION_CREATE
    || path === URL_CART_BILLING
    || path === URL_CART_BILLING_PAYMENT)
    && auth.get('jwt')
  )
}

function isAnonymousCheckout ({ state }) {
  const { resolver, auth } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    (isPlans(path)
    || path === URL_ACCOUNT_CREATION
    || path === URL_CART_ACCOUNT_CREATION_CREATE
    || path === URL_CART_BILLING
    || path === URL_CART_BILLING_PAYMENT)
    && !auth.get('jwt')
  )
}

function isCartAccountCreatePage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    path === URL_CART_ACCOUNT_CREATION_CREATE
  )
}

function isCartPaymentPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    path === URL_CART_BILLING_PAYMENT
  )
}

function isCartChooseBillingPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    path === URL_CART_BILLING
  )
}

function isCartConfirmationPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    path === URL_CART_CONFIRMATION
  )
}

function renderCartAbandon ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    !isCart(path)
    && !isPlans(path)
    && !isGo(path)
    && !isLogout(path)
    && !isGetStarted(path)
    && !isGiftPage(path)
    && path !== '/dev/adyen' // adyen-test-page
  )
}

function shouldOverrideStartDate (props) {
  const {
    user, plans, userAccount, auth,
  } = props
  const creationSource = (user.getIn(['data', 'creation_source']))
  const userIsEntitled = isEntitled(auth.get('subscriptions', List()))
  const productRatePlanId = plans.getIn(['selection', 'id'])
  const zuoraAccount = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'billingAccountId'])

  if (
    ((creationSource === ACCOUNT_TYPE_FMTV_GIFT
      || creationSource === ACCOUNT_TYPE_FMTV_COMP
      || creationSource === ACCOUNT_TYPE_ZUORA_GIFT)
    && userIsEntitled
    && !zuoraAccount
    && productRatePlanId !== PLAN_ID_LIVE)
    // this accounts for users in a gift period that *also* have a zuora account, either bc they
    // bought a gift for someone else or they were in a cancelled state and previously had
    // a billingAccountId
    || userAccount.getIn(['details', 'data', 'gift', 'status']) === GIFT_SUBSCRIPTION_STATE.ACTIVE
  ) {
    return true
  }
  return false
}

function buildMembershipDataLayerObject (option) {
  return {
    event: 'customEvent',
    eventCategory: 'paypal',
    eventAction: option,
    eventLabel: 'cart-paypal',
  }
}

function onAuthRenewSuccess (options, dispatch) {
  const {
    auth,
    inboundTracking = Map(),
  } = options

  if (
    inboundTracking.getIn(['data', 'ci_id'])
    || inboundTracking.getIn(['data', 'ci_type'])
  ) {
    setContentImpression({
      auth: _get(auth, 'jwt'),
      timestamp: new Date(),
      contentId: inboundTracking.getIn(['data', 'ci_id']),
      contentType: inboundTracking.getIn(['data', 'ci_type']),
    })
  }

  dispatch(actions.setCheckoutOrderProcessing(false))
  dispatch(actions.setCheckoutOrderComplete(true))
}

/**
 * Handle the auth login response and set any additional user data
 */
async function onAuthLoginFeatureTracking (options = {}) {
  const { auth, user } = options
  const userLanguages = user.getIn(['data', 'language'], List())
  if (userLanguages.size > 0) {
    // No matter what happens with Feature tracking resolve with auth
    try {
      await setFeatureTrackingDataPersistent({
        auth: fromJS(auth),
        data: Map({ userLanguages }),
      })
    } catch (e) {
      // Do nothing
    }
  }
}

function getCheckoutStep (state) {
  const { resolver, plans } = state
  const path = resolver.getIn(['data', 'path'])
  const selection = plans.get('selection', Map())
  let step

  switch (path) {
    case URL_ACCOUNT_CREATION:
    case URL_CART_ACCOUNT_CREATION_CREATE:
      step = selection.size === 0 ? CHECKOUT_STEP_ONE : CHECKOUT_STEP_TWO
      break
    case URL_PLAN_SELECTION:
    case URL_PLAN_SELECTION_PLANS:
      step = CHECKOUT_STEP_TWO
      break
    case URL_CART_BILLING:
    case URL_CART_BILLING_PAYMENT:
      step = CHECKOUT_STEP_THREE
      break
    default:
      // do nothing
  }

  return step
}

function getCheckoutEventStep (state) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])
  let step

  switch (path) {
    case URL_ACCOUNT_CREATION:
      step = CHECKOUT_EVENT_STEP_ONE
      break
    case URL_CART_ACCOUNT_CREATION_CREATE:
      step = CHECKOUT_EVENT_STEP_TWO
      break
    case URL_PLAN_SELECTION:
      step = CHECKOUT_EVENT_STEP_THREE
      break
    case URL_PLAN_SELECTION_PLANS:
      step = CHECKOUT_EVENT_STEP_FOUR
      break
    case URL_CART_BILLING:
      step = CHECKOUT_EVENT_STEP_FIVE
      break
    case URL_CART_BILLING_PAYMENT:
      step = CHECKOUT_EVENT_STEP_SIX
      break
    case URL_CART_CONFIRMATION:
      step = CHECKOUT_EVENT_STEP_SEVEN
      break
    default:
      // do nothing
  }

  return step
}

// -----------------------------------
// Watcher for checking data "server side" for setting the step and event step
// -----------------------------------
export function onCheckoutStepHydrationComplete ({ after }) {
  return after(SET_APP_BOOTSTRAP_PHASE, async ({ dispatch, state }) => {
    const { app, checkout } = state
    const previousStep = checkout.get('step')
    const previousEventStep = checkout.get('eventStep')
    const step = getCheckoutStep(state)
    const eventStep = getCheckoutEventStep(state)

    // set the checkout step
    if (app.get('bootstrapComplete') && step && step !== previousStep) {
      dispatch({
        type: actions.SET_CHECKOUT_STEP,
        payload: step,
      })

      // Send emarsys "go" command
      emarsysSend()
    }

    // set the checkout step event
    if (eventStep && eventStep !== previousEventStep) {
      dispatch({
        type: actions.SET_CHECKOUT_EVENT_STEP,
        payload: eventStep,
      })
    }
  })
    .when(isCheckoutPage)
}

// -----------------------------------
// Watcher for componentDidMount/DidUpdate for setting the step and event step
// -----------------------------------
export function onCheckoutStepMountAndUpdate ({ after }) {
  return after(SET_RESOLVER_DATA, async ({ dispatch, state }) => {
    const { checkout } = state
    const previousStep = checkout.get('step')
    const previousEventStep = checkout.get('eventStep')
    const step = getCheckoutStep(state)
    const eventStep = getCheckoutEventStep(state)

    // set the checkout step
    if (step && step !== previousStep) {
      dispatch({
        type: actions.SET_CHECKOUT_STEP,
        payload: step,
      })
    }

    // set the checkout step event
    if (eventStep && eventStep !== previousEventStep) {
      dispatch({
        type: actions.SET_CHECKOUT_EVENT_STEP,
        payload: eventStep,
      })

      // Send emarsys "go" command on every url in plan flow
      emarsysSend()
    }
  })
    .when(isCheckoutPage)
}

// -----------------------------------
// Watcher for setCheckoutStep
// -----------------------------------
export function onSetCheckoutStep ({ after }) {
  return after(actions.SET_CHECKOUT_STEP, async ({ dispatch, state }) => {
    const { checkout, auth } = state
    const accountInfo = checkout.get('account', Map())
    const checkoutStep = checkout.get('step')
    const authToken = auth.get('jwt')

    // check to see what step the user is on and if they have cart account info
    if (!authToken && accountInfo.size === 0 && checkoutStep >= CHECKOUT_STEP_TWO) {
      dispatch({
        type: NAVIGATION_HISTORY_PUSH,
        payload: { url: URL_ACCOUNT_CREATION },
      })
    }
  })
    .when(isCheckoutPage)
}

// -----------------------------------
// Watcher for setCheckoutEventStep
// -----------------------------------
export function onSetCheckoutEventStep ({ after }) {
  return after(actions.SET_CHECKOUT_EVENT_STEP, async ({ dispatch, action, state }) => {
    const { payload } = action
    const { plans } = state

    // set the checkout step event
    if (payload) {
      const eventData = {
        step: payload,
      }
      const selection = plans.get('selection', Map())

      if (selection.size > 0) {
        _set(eventData, 'selection', selection)
      }

      const event = buildCheckoutStepDataLayerObject(eventData)

      dispatch({
        type: SET_EVENT_CART_CHECKOUT_STEP,
        payload: { event },
      })
    }
  })
    .when(isCheckoutPage)
}

// -----------------------------------
// Watcher for checking data "server side" on the Cart Access Info page
// -----------------------------------
export function onCheckoutCartAccessDeniedHydrationComplete ({ before }) {
  return before(SET_APP_BOOTSTRAP_PHASE, async ({ dispatch, state, action }) => {
    const { app, auth } = state
    const { payload } = action
    const { isComplete } = payload
    const previousBootstrapComplete = app.get('bootstrapComplete')
    const authToken = auth.get('jwt')

    // trigger the login modal for anonymous
    if (!authToken && isComplete && isComplete !== previousBootstrapComplete) {
      dispatch({
        type: SET_DIALOG_COMPONENT_NAME,
        payload: { name: TYPE_LOGIN },
      })
    }
  })
    .when(isCartAccessDeniedPage)
}

// -----------------------------------
// Watcher for componentDidMount/DidUpdate on the Cart Access Info page
// -----------------------------------
export function onCheckoutCartAccessDeniedMountAndUpdate ({ after }) {
  return after(SET_RESOLVER_DATA, async ({ dispatch, state }) => {
    const { auth } = state
    const authToken = auth.get('jwt')

    // trigger the login modal for anonymous
    if (!authToken) {
      dispatch({
        type: SET_DIALOG_COMPONENT_NAME,
        payload: { name: TYPE_LOGIN },
      })
    }
  })
    .when(isCartAccessDeniedPage)
}

// -----------------------------------
// Watcher for determining cart access when logged in
// -----------------------------------
export function onCheckoutAccessCheck ({ after }) {
  return after([
    SET_RESOLVER_DATA,
    SET_APP_BOOTSTRAP_PHASE,
    SET_PAYTRACK_DATA_LAST_TRANSACTION,
    SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS_WITH_DETAILS,
    SET_USER_DATA,
  ], async ({ dispatch, state }) => {
    const {
      user, auth, userAccount, paytrack, checkout, plans,
    } = state
    let entitled = user.getIn(['data', 'entitled'])
    const billingSubscriptionsProcessing = userAccount.get('billingSubscriptionsProcessing')
    const userBillingSubscriptions = userAccount.getIn(['details', 'data', 'billing', 'subscriptions'])
    const paytrackProcessing = paytrack.get('processing')
    const paytrackLastTransaction = paytrack.get('lastTransaction')
    const accessCheckDataReady = !billingSubscriptionsProcessing && !paytrackProcessing
      && userBillingSubscriptions && paytrackLastTransaction
    const checkoutStep = checkout.get('step')
    const plansLocalizedProcessing = plans.get('processingLocalized')
    const selectedPlan = plans.get('selection')
    const isGift = planIsGift(selectedPlan)

    // we don't know if the user is entitled, so lets find out
    if (_isUndefined(entitled)) {
      try {
        const idExpires = auth.get('idExpires')
        const subscriptions = auth.get('subscriptions', List()).toJS()

        // set user processing
        dispatch({
          type: SET_USER_PROCESSING,
          payload: true,
        })

        entitled = await getUserEntitled(idExpires, subscriptions)

        dispatch({
          type: SET_USER_DATA_ENTITLED,
          payload: { value: entitled },
        })
      } catch (e) {
        dispatch({
          type: SET_USER_PROCESSING,
          payload: false,
        })
      }
    }

    // all the data is ready, so lets check the users access
    if (accessCheckDataReady) {
      const checkoutAllowed = userCheckoutAllowed({
        auth, user, userAccount, paytrack,
      }, entitled)
      const checkoutAllowedNoPlanSelected = checkoutAllowed
        && checkoutStep >= CHECKOUT_STEP_THREE
        && !plansLocalizedProcessing
        && (!selectedPlan || isGift)

      if (!checkoutAllowed) {
        // if the user is not allowed to checkout, send them to the cart access denied page
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_CART_ACCESS_DENIED },
        })
        dispatch(removeInterstitial())
      } else if (checkoutAllowedNoPlanSelected) {
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_ACCOUNT_CREATION },
        })
      }
    }

    // kickoff check for myqee email
    const email = auth.get('email')
    const userAcquisitions = user.get('userAcquisitions')
    if (email && !userAcquisitions) dispatch(getUserEmailAvailability(email))
  })
    .when(isAuthenticatedCheckout)
}

// -----------------------------------
// Watcher for determining cart access when anonymous
// -----------------------------------
export function onAnonymousCheckoutAccessCheck ({ after }) {
  return after([
    SET_RESOLVER_DATA,
    SET_APP_BOOTSTRAP_PHASE,
  ], async ({ dispatch, state }) => {
    const { checkout, plans } = state
    const checkoutStep = checkout.get('step')
    const plansLocalizedProcessing = plans.get('processingLocalized')
    const selectedPlan = plans.get('selection', Map())
    // if checkout step should have a plan selection and doesn't
    // or if the plan that was selected is a gift, redirect
    const noPlanSelected = checkoutStep >= CHECKOUT_STEP_TWO
        && !plansLocalizedProcessing
        && (!selectedPlan || planIsGift(selectedPlan))
    const noAccountInfo = checkout.get('account', Map()).size === 0 && checkoutStep >= CHECKOUT_STEP_TWO

    if (noAccountInfo && noPlanSelected) {
      // if the user is not allowed to checkout, send them back to cart account creation
      dispatch({
        type: NAVIGATION_HISTORY_PUSH,
        payload: { url: URL_ACCOUNT_CREATION },
      })
    }
  })
    .when(isAnonymousCheckout)
}

export function watchSetPlansData ({ after }) {
  return after(SET_PLANS_DATA, async ({ dispatch, state }) => {
    const {
      plans, userAccount, user, auth,
    } = state
    const selectedPlan = plans.get('selection') || Map()
    const selectedSku = selectedPlan.get('sku')
    const currentPlan = selectedSku ? (plans.getIn(['data', 'plans']) || Map()).find((p) => p.get('sku') === selectedSku) : Map()
    const currencyIso = getAuthIsLoggedIn(auth) && currentPlan.size > 0 ? currentPlan.get('currencyIso') : null

    // If the user changes their language while in the checkout flow with a plan already selected
    // then set their selection again so that we pick up the proper translations
    if (selectedPlan.size > 0
      && !selectedPlan.equals(currentPlan)
      && !planIsGift(selectedPlan)) {
      const language = user.getIn(['data', 'language'])
      const latamPricing = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'latamPricing'])
      const currency = latamPricing ? LTM : currencyIso

      try {
        dispatch(setPlansLocalizedSelection({ plan: currentPlan, language, currency }))
      } catch (error) {
        // Do Nothing for now
      }
    }
  })
    .when(isCheckoutPage)
}

/**
 * Watcher for the account create data being set.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchAccountCreateData ({ after }) {
  return after(actions.SET_CHECKOUT_ACCOUNT_CREATE_DATA, async ({ dispatch, state, action }) => {
    const {
      auth,
      plans,
      user,
    } = state
    const { payload: data } = action
    const emailCaptureChecked = _get(data, 'emailOptIn', false)
    const { dataLayer } = global
    const email = _get(data, 'email')
    const password = _get(data, 'password')
    const firstName = _get(data, 'firstName')
    const lastName = _get(data, 'lastName')
    const emailOptIn = _get(data, 'emailOptIn')
    const language = user.getIn(['data', 'language'], List([EN])).toJS()
    const selectedPlan = plans.get('selection')

    if (emailCaptureChecked && dataLayer) {
      dataLayer.push({
        event: 'customEvent',
        eventCategory: 'user engagement',
        eventAction: 'opt-in selection',
        eventLabel: 'receive emails-account creation',
      })
    }

    dispatch(actions.setCheckoutUserData(data))
    dispatch(setCartAbandonEmailDataLayer(buildEmailDataLayerObject('cart abandon')))
    // If the user is logged in, redirect them to the plan selection page or account create
    // Otherwise, create a new user account for them
    if (getAuthIsLoggedIn(auth)) {
      if (selectedPlan && !planIsGift(selectedPlan)) {
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_CART_BILLING },
        })
      } else {
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_PLAN_SELECTION },
        })
      }
    } else {
      const { googleRecaptchaSiteKey } = getConfig()

      dispatch({
        type: SET_USER_CREATE_PROCESSING,
        payload: true,
      })
      await getGoogleRecaptchaScript()
      const { grecaptcha } = global

      if (grecaptcha) {
        await fromCallbackPromise((cb) => grecaptcha.ready(() => cb()))
        const token = await grecaptcha.execute(googleRecaptchaSiteKey, {
          action: CAPTCHA_ACTION_BILLING_PAYMENT_FORM_VIEW,
        })
        const tokenResponse = await getCaptchaVerifyToken({ token })
        const { valid } = tokenResponse

        if (valid) {
          const newUser = await userCreate({
            language,
            email,
            password,
            firstName,
            lastName,
            emailOptIn,
          })

          dispatch({
            type: SET_USER_CREATE_DATA,
            payload: { data: newUser, processing: false },
          })
        }
        dispatch({
          type: SET_USER_CREATE_CAPTCHA_VALID,
          payload: valid,
        })
      } else {
        dispatch({
          type: SET_USER_CREATE_CAPTCHA_VALID,
          payload: false,
        })
        dispatch({
          type: SET_USER_CREATE_PROCESSING,
          payload: false,
        })
      }
    }
  })
    .when(isCartAccountCreatePage)
}

/**
 * Watcher for the new user create data being set.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchSetUserCreateData ({ after }) {
  return after(SET_USER_CREATE_DATA, async ({ dispatch, state }) => {
    const {
      user,
      page,
      plans,
      checkout,
      staticText,
      inboundTracking,
    } = state
    const newUserSuccess = user.getIn(['newUser', 'data', 'success'])
    const loginErrorMessage = staticText.getIn(['data', 'cartAccountCreatePageV2', 'data', 'userLoginError'])
    const { appCountry } = config
    const email = checkout.getIn(['account', 'email'])
    const firstName = checkout.getIn(['account', 'firstName'])
    const lastName = checkout.getIn(['account', 'lastName'])
    const emailOptIn = checkout.getIn(['account', 'emailOptIn'])
    const uid = user.getIn(['newUser', 'data', 'uid'])
    const username = user.getIn(['newUser', 'data', 'username'])
    const language = getPrimary(user.getIn(['data', 'language'], List([EN])))
    const locale = page.get('locale')
    const today = formatDateTime(undefined, locale, dateFormatString)
    const utmCampaign = inboundTracking.getIn(['data', 'utm_campaign'], '')
    const country = plans.getIn(['data', 'plans', 0, 'country'], appCountry)
    const xff = user.get('xff') || user.getIn(['data', 'xff'])
    const requestStatus = user.getIn(['newUser', 'data', 'requestStatus'])
    const errorDetail = user.getIn(['newUser', 'data', 'errorDetail'])
    const errorMeta = user.getIn(['newUser', 'data', 'errorMeta'])
    const userCreateMessages = user.getIn(['newUser', 'data', 'messages'], List()).join([' | '])
    const userCreateCodes = user.getIn(['newUser', 'data', 'codes'], List()).join([' | '])
    let loginSuccess = false

    if (newUserSuccess) {
      dispatch({
        type: actions.SET_CHECKOUT_REACTIVATION,
        payload: false,
      })

      // fire event sign_up
      const signUpEvent = buildSignUpObject({ uid })
      dispatch({
        type: SET_EVENT_SIGN_UP,
        payload: { event: signUpEvent },
      })

      // send facebook lead event
      dispatch({
        type: SET_EVENT_LEAD,
        payload: email,
      })

      // send data to Emarsys
      const fields = {
        email,
        country,
        first_name: firstName,
        last_name: lastName,
        registration_language: language,
        drupal_user_id: uid,
        entitled: false,
        creation_source: 'Zuora',
        cart_start_date: today,
        campaign_acq: utmCampaign,
      }
      postEmailCapture({
        email, optin: emailOptIn, fields, source: '',
      })

      const login = await dispatch(doAuthLogin({
        username,
        password: checkout.getIn(['account', 'password']),
      }))
      loginSuccess = _get(login, 'success')

      // if login fails show the login modal
      if (!loginSuccess) {
        dispatch({
          type: SET_DIALOG_COMPONENT_NAME,
          payload: { name: TYPE_LOGIN },
        })
        dispatch({
          type: SET_DIALOG_OPTIONS,
          payload: { customMessage: loginErrorMessage },
        })
      }
    }

    const dataNewRelic = {
      type: DEVICE,
      language,
      country,
      utmCampaign,
      utmString: inboundTracking.getIn(['data', 'strings', 'utm'], ''),
      rfd: inboundTracking.getIn(['data', 'rfd'], ''),
      source: inboundTracking.getIn(['data', 'source'], ''),
      username,
      userCreated: newUserSuccess,
      userLogin: newUserSuccess ? loginSuccess : null,
      requestStatus,
      errorMeta,
      errorDetail,
      userCreateMessages,
      userCreateCodes,
      anonymousUuid: user.getIn(['data', 'anonymousUuid']),
      xff,
    }

    addNewRelicAction('CheckoutUserCreate', dataNewRelic)
  })
    .when(isCartAccountCreatePage)
}

/**
 * Watcher for login success on the cart account create page.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchAccountCreateLoginSuccess ({ after }) {
  return after(SET_AUTH_LOGIN_SUCCESS, async ({ state, dispatch }) => {
    const {
      auth,
      inboundTracking,
      user,
      plans,
      checkout,
    } = state
    const selectedPlan = plans.get('selection')
    const termsChecked = checkout.getIn(['account', 'terms'])

    dispatch(removeInterstitial())

    // send the user to plan selection after login
    if (selectedPlan && termsChecked) {
      dispatch({
        type: NAVIGATION_HISTORY_PUSH,
        payload: { url: URL_CART_BILLING },
      })
    } else if (!selectedPlan && termsChecked) {
      dispatch({
        type: NAVIGATION_HISTORY_PUSH,
        payload: { url: URL_PLAN_SELECTION },
      })
    }
    // Setup anything related to feature tracking now that we have auth
    await onAuthLoginFeatureTracking({
      auth: auth.get('jwt'),
      user,
      setFeatureTrackingDataPersistent,
    })

    // set the content impression
    if (
      inboundTracking.getIn(['data', 'ci_id'])
      || inboundTracking.getIn(['data', 'ci_type'])
    ) {
      setContentImpression({
        auth: auth.get('jwt'),
        timestamp: new Date(),
        contentId: inboundTracking.getIn(['data', 'ci_id']),
        contentType: inboundTracking.getIn(['data', 'ci_type']),
      })
    }
  })
    .when(isCartAccountCreatePage)
}

/**
 * Watcher for login dialog so we can reset the options.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchAccountCreateLoginDialog ({ after }) {
  return after(SET_DIALOG_COMPONENT_NAME, async ({ dispatch, action }) => {
    const { payload } = action
    const { name } = payload

    if (name === TYPE_LOGIN) {
      dispatch({
        type: SET_DIALOG_OPTIONS,
        payload: {},
      })
    }
  })
    .when(isCartAccountCreatePage)
}

/**
 * Watcher for a plan being selected.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchSetPlansSelection ({ after }) {
  return after(
    [SET_PLANS_SELECTION, actions.SET_CHECKOUT_ACCOUNT_CREATE_DATA],
    async ({ state, dispatch }) => {
      const { checkout, plans, user } = state
      const email = checkout.getIn(['account', 'email']) || user.getIn(['data', 'mail'])
      const emailOptIn = checkout.getIn(['account', 'emailOptIn'])
      const selectedPlan = plans.get('selection')

      const planName = plans.getIn(['selection', 'name'])
      const planId = plans.getIn(['selection', 'id'])

      // send the GA event when a plan is selected
      if (selectedPlan) {
        const beginCheckoutEvent = buildBeginCheckoutObject({ selectedPlan, user })
        dispatch({
          type: SET_EVENT_BEGIN_CHECKOUT,
          payload: { event: beginCheckoutEvent },
        })
      }

      // if a plan is selected, send info to Emarsys
      if (selectedPlan && email) {
        const fields = {
          plan_id: planId,
          plan_name: planName,
        }
        postEmailCapture({
          email, optin: emailOptIn, fields, source: '',
        })
      }
    },
  )
}

/**
 * Watcher for credit card and PayPal checkout.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCheckoutPaymentType ({ after }) {
  return after(
    [
      actions.SET_CHECKOUT_PAYPAL_PAYMENT,
      SET_PAYMENT_DATA,
    ],
    async ({ state, dispatch, action }) => {
      const {
        checkout,
        auth,
        user,
        userAccount,
        page,
        plans,
        inboundTracking,
        payment,
      } = state
      const userInfo = checkout.get('account', Map())
      const emailOptIn = userInfo.get('emailOptIn')
      let paymentInfo = {}
      // If the user is logged in, get their currency iso from their account
      // Otherwise get the currency iso from the plans
      const currencyIso = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'currencyIso'])
        || plans.getIn(['selection', 'currencyIso'])
        || USD
      const isGiftSubscriptionActive = userAccount.getIn(['details', 'data', 'gift', 'currentGift', 'status']) === GIFT_SUBSCRIPTION_STATE.ACTIVE
      const userEntitlementsEndDate = user.getIn(['data', 'userEntitlements', 'end'])
      const giftEndDate = _max([getUnixTimestamp(userAccount.getIn(['details', 'data', 'gift', 'paidThroughDate'])), userEntitlementsEndDate])
      const entitlementEndDate = isGiftSubscriptionActive ? giftEndDate : userEntitlementsEndDate
      const entitlementEnd = parseInt(entitlementEndDate, 10) * 1000
      const locale = page.get('locale')
      const formattedEndDate = formatDateTime(entitlementEnd, locale, dateFormatString)
      const productRatePlanId = plans.getIn(['selection', 'id'])
      const startDateOverrideInfo = shouldOverrideStartDate(state) ? { formattedEndDate } : null
      const reactivation = checkout.get('reactivation')
      const paymentSuccess = payment.getIn(['data', 'payments', 'success'])
      const paymentResultCode = payment.getIn(['data', 'payments', 'data', 'resultCode'])
      const paymentIsAuthorized = paymentResultCode === ADYEN_PAYMENT_RESPONSE_CODE_AUTHORIZED
      const paymentAuthorizationUuid = payment.getIn(['data', 'payments', 'authorization', 'uuid'])
      // this orderReference is used for our braintree PayPal integration
      // as the Adyen payment flow doesn't need this because we have the paymentAuthorizationUuid
      let orderReference

      // if the Adyen payment wasn't successful then bail
      if (action.type === SET_PAYMENT_DATA && !paymentSuccess) {
        return
      }

      if (planIsGift(plans.get('selection'))) {
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_PLAN_SELECTION },
        })
        return
      }

      if (action.type === actions.SET_CHECKOUT_PAYPAL_PAYMENT) {
        orderReference = uuidv4()
        paymentInfo = {
          currencyIso,
          country: checkout.getIn(['paypalPaymentInfo', 'details', 'billingAddress', 'countryCode']),
          postalCode: checkout.getIn(['paypalPaymentInfo', 'details', 'billingAddress', 'postalCode']),
          state: checkout.getIn(['paypalPaymentInfo', 'details', 'billingAddress', 'state']),
          payPal: {
            payPalNonce: checkout.getIn(['paypalPaymentInfo', 'nonce']),
          },
          productRatePlanId,
        }

        // create an order reference id to be used specifically in the case of paypal
        dispatch({
          type: actions.SET_CHECKOUT_ORDER_REFERENCE,
          payload: orderReference,
        })
      } else if (action.type === SET_PAYMENT_DATA) {
        paymentInfo = {
          currencyIso,
          country: payment.getIn(['data', 'payments', 'billingAddress', 'country']) || payment.getIn(['data', 'billingInfo', 'billingAddress', 'country']),
          postalCode: payment.getIn(['data', 'payments', 'billingAddress', 'postalCode']) || payment.getIn(['data', 'billingInfo', 'billingAddress', 'postalCode']),
          productRatePlanId,
          adyen: {
            shopperReference: payment.getIn(['data', 'payments', 'data', 'additionalData', 'recurring.shopperReference']),
            ...(paymentIsAuthorized) && { recurringDetailReference: payment.getIn(['data', 'payments', 'data', 'additionalData', 'recurring.recurringDetailReference']) },
            cardSummary: payment.getIn(['data', 'payments', 'data', 'additionalData', 'cardSummary']),
          },
        }
      }

      // @TODO: this is firing for everyone, but the event looks like it is PayPal specific
      // need to determine if this is really working correctly (as intended)
      setEventStartMembershipClicked(
        buildMembershipDataLayerObject(MEMBERSHIP_BUTTON_CLICKED),
      )

      if (window.scrollTo) {
        requestAnimationFrame(() => window.scrollTo(0, 0))
      }

      dispatch(
        actions.processCheckoutOrder({
          auth,
          paymentInfo,
          tracking: inboundTracking,
          startDateOverrideInfo,
          reactivation,
          emailOptIn,
          fbEventId: paymentAuthorizationUuid || orderReference,
        }),
      )
    },
  )
    .when(isCartPaymentPage)
}

/**
 * Watcher for checkout order data, redirecting the user to the cart confirmation page.
 * This is used for both CC and PayPal orders.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchSetCheckoutOrderData ({ after }) {
  return after(
    actions.SET_CHECKOUT_ORDER_DATA,
    async (
      {
        state,
        dispatch,
      },
    ) => {
      const {
        checkout,
        auth,
        inboundTracking,
        payment,
        plans,
        resolver,
      } = state

      if (checkout.getIn(['orderData', 'success'])) {
        const authorizationUuid = payment.getIn(['data', 'payments', 'authorization', 'uuid'])
        const orderReference = checkout.get('orderReference')

        // send authorization data when checkout is complete
        if (authorizationUuid) {
          updateAdyenAuthorization({
            auth,
            uuid: authorizationUuid,
            billingAccountCreated: true,
          })
        }

        // server side purchase event
        if (getConfig().features.events.server) {
          const fbp = getCookie('_fbp')

          dispatch({
            type: CREATE_SERVER_EVENT,
            payload: {
              event: SERVER_EVENT_PURCHASE,
              data: {
                eventName: FACEBOOK_EVENT_NAME_PURCHASE,
                actionSource: FACEBOOK_EVENT_ACTION_SOURCE,
                eventSourceUrl: `${URL_GAIA_PROD}${resolver.get('path')}`,
                eventId: authorizationUuid || orderReference,
                ...(fbp) && { fbp },
                data: {
                  currency: plans.getIn(['selection', 'currencyIso'], USD),
                  price: plans.getIn(['selection', 'costs'], []).first(),
                  orderId: checkout.getIn(['orderData', 'billing', 'accountNumber']) || checkout.getIn(['orderData', 'billingAccountNumber']),
                },
              },
            },
          })
        }

        const dataNewRelic = {
          type: DEVICE,
          ch: inboundTracking.getIn(['data', 'ch'], ''),
          ci_id: inboundTracking.getIn(['data', 'ci_id'], null),
          ci_type: inboundTracking.getIn(['data', 'ci_type'], ''),
          rfd: inboundTracking.getIn(['data', 'rfd'], ''),
          source: inboundTracking.getIn(['data', 'source'], ''),
          utmString: inboundTracking.getIn(['data', 'strings', 'utm'], ''),
          utm_campaign: inboundTracking.getIn(['data', 'utm_campaign'], ''),
          utm_content: inboundTracking.getIn(['data', 'utm_content'], ''),
          utm_medium: inboundTracking.getIn(['data', 'utm_medium'], ''),
          utm_source: inboundTracking.getIn(['data', 'utm_source'], ''),
          utm_term: inboundTracking.getIn(['data', 'utm_term'], ''),
          username: checkout.getIn(['orderData', 'newUsername']) || auth.get('username'),
          orderNumber: checkout.getIn(['orderData', 'billing', 'orderNumber'], '') || checkout.getIn(['orderData', 'billingResponse', 'orderNumber']),
        }

        addNewRelicAction('SignupSuccess', dataNewRelic)

        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_CART_CONFIRMATION },
        })

        if (window.scrollTo) {
          requestAnimationFrame(() => window.scrollTo(0, 0))
        }
      }
    },
  )
}

/**
 * Watcher for order errors.
 * This is used for both CC and PayPal orders.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchSetCheckoutOrderError ({ after }) {
  return after(actions.SET_CHECKOUT_ORDER_ERROR, async ({ state, dispatch }) => {
    const {
      user, auth, resolver, checkout,
    } = state

    if (velocityCheckActive) {
      const velocityPage = getVelocityCheckActionLocation({ auth, checkout, resolver })
      const userUuid = user.getIn(['data', 'uuid'])

      // since the order failed, call the velocity check again
      const fp = await FingerprintJS.load({
        apiKey: fingerprintJsApiKey,
        endpoint: fingerprintJsSubdomain,
        scriptUrlPattern: [
          // This endpoint will be used primarily
          `/fingerprintjs/v3/${fingerprintJsApiKey}/loader_v3.8.3.js`,
          // The default endpoint will be used if the primary fails
          FingerprintJS.defaultScriptUrlPattern,
        ],
      })
      const fpResult = await fp.get({
        timeout: 10000,
      })
      const fingerprintId = _get(fpResult, 'visitorId')

      dispatch({
        type: SET_VELOCITY_CHECK_PROCESSING,
        payload: true,
      })

      // if order is not successful, then get a new set of velocity data
      const velocity = await checkVelocity(
        {
          userInfoUuid: userUuid,
          fingerprintId,
          page: velocityPage,
        },
      )

      dispatch({
        type: SET_VELOCITY_CHECK_DATA,
        payload: { data: velocity, processing: false },
      })
    }
  })
}

/**
 * Watcher for redirecting the user to cart billing payment page when a paypal nonce has been set.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchSetCheckoutPaypalNonce ({ after }) {
  return after(actions.SET_CHECKOUT_PAYPAL_NONCE, async ({ state, dispatch }) => {
    const { checkout } = state

    if (checkout.get('paymentType') === PAYMENT_TYPE_PAYPAL) {
      dispatch({
        type: NAVIGATION_HISTORY_PUSH,
        payload: { url: URL_CART_BILLING_PAYMENT },
      })

      scrollToTop()
    }
  }).when(isCartChooseBillingPage)
}

/**
 * Watcher for client side and server side navigation to the cart confirmation page.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCartConfirmationPage ({ after }) {
  return after(
    [
      SET_RESOLVER_DATA,
      SET_APP_BOOTSTRAP_PHASE,
    ],
    async ({
      state, prevState, dispatch, action,
    }) => {
      const {
        app,
        auth,
        inboundTracking,
        checkout,
      } = state
      const { app: prevApp } = prevState
      const bootstrapComplete = app.get('bootstrapComplete')
      const prevBootstrapComplete = prevApp.get('bootstrapComplete')
      const loggedIn = getAuthIsLoggedIn(auth)
      const orderData = checkout.get('orderData', Map())

      // if the user is coming directly to this url, or if they refresh the page
      // we will have no redux data, therefore we will be unable to render the page
      // properly, so send them to the homepage or plan selection
      if (action.type === SET_APP_BOOTSTRAP_PHASE && bootstrapComplete !== prevBootstrapComplete) {
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: loggedIn ? URL_HOME : URL_ACCOUNT_CREATION },
        })
        return
      }

      // if the user is redirected from the payment page to the confirmation page
      if (action.type === SET_RESOLVER_DATA && orderData.size > 0) {
        const authResult = await dispatch(doAuthRenew(auth))
        dispatch(setMessageBoxVisible(false))
        onAuthRenewSuccess({
          auth: authResult,
          inboundTracking,
        }, dispatch)
      }
    },
  )
    .when(isCartConfirmationPage)
}

/**
 * Watcher for login success on the cart confirmation page.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCartConfirmationLoginSuccess ({ after }) {
  return after(SET_AUTH_LOGIN_SUCCESS, async ({ state }) => {
    const { auth, inboundTracking, user } = state
    // Setup anything related to feature tracking now that we have auth
    await onAuthLoginFeatureTracking({
      auth: auth.get('jwt'),
      user,
      setFeatureTrackingDataPersistent,
    })

    // set the content impression
    if (
      inboundTracking.getIn(['data', 'ci_id'])
      || inboundTracking.getIn(['data', 'ci_type'])
    ) {
      setContentImpression({
        auth: auth.get('jwt'),
        timestamp: new Date(),
        contentId: inboundTracking.getIn(['data', 'ci_id']),
        contentType: inboundTracking.getIn(['data', 'ci_type']),
      })
    }
  })
    .when(isCartConfirmationPage)
}

/**
 * Watcher for login failed on the cart confirmation page.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCartConfirmationLoginFailed ({ after }) {
  return after(SET_AUTH_LOGIN_FAILED, async ({ dispatch }) => {
    dispatch({
      type: SET_DIALOG_COMPONENT_NAME,
      payload: { name: TYPE_LOGIN },
    })
  })
    .when(isCartConfirmationPage)
}

/**
 * Watcher for getting the user account billing subscription details on the confirmation page.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchUserAccountDataBillingSubscriptions ({ after }) {
  return after(
    SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS_WITH_DETAILS,
    async ({ state, dispatch }) => {
      const {
        userAccount,
        checkout,
        user,
        plans,
        page,
        eventTracking,
      } = state
      const email = user.getIn(['data', 'mail'])
      const emailOptIn = checkout.getIn(['account', 'emailOptIn'])
      const uuid = user.getIn(['data', 'uuid'])
      const uid = user.getIn(['data', 'uid'])
      const planId = plans.getIn(['selection', 'id'])
      const planName = plans.getIn(['selection', 'name'])
      const trialPeriod = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'inTrialSegment'])
      const locale = page.get('locale')
      const today = formatDateTime(undefined, locale, dateFormatString)
      const mostRecentAmount = _toNumber(parseFloat(userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'charges', 0, 'price'], 0)).toFixed(2))
      const currencyIso = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'currencyIso'])
      const paidThroughDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paidThroughDate'])
      const fullPlanPrice = List.isList(plans.getIn(['selection', 'costs'])) ? _toNumber(parseFloat(plans.getIn(['selection', 'costs']).last()).toFixed(2)) : 0
      const isReactivation = checkout.get('reactivation')
      const lastPurchasedEvent = eventTracking.getIn(['lastPurchasedEvent'], false)

      // Add new purchase events, if we haven't sent one already
      if (!lastPurchasedEvent) {
        const purchasedEventData = {
          transactionId: checkout.getIn(['orderData', 'billing', 'orderNumber']) || checkout.getIn(['orderData', 'billingResponse', 'orderNumber']),
          userId: uid,
          currency: currencyIso,
          itemId: plans.getIn(['selection', 'sku'], ''),
          itemName: plans.getIn(['selection', 'heading'], ''),
        }

        const purchasedEvent = buildPurchaseObject(purchasedEventData)
        const purchasedPlanEvent = buildPurchasedPlanObject(purchasedEventData)

        dispatch({
          type: SET_EVENT_PURCHASE,
          payload: { event: purchasedEvent },
        })

        dispatch({
          type: SET_EVENT_PURCHASED_PLAN,
          payload: { event: purchasedPlanEvent },
        })
      }

      const fields = {
        entitled: true,
        plan_id: planId,
        plan_name: planName,
        trial_period: trialPeriod,
        plan_start_date: today,
        subscription_start_date: today,
        ...(!isReactivation) && { cart_complete_date: today },
        ...(isReactivation) && { cart_reactivation_date: today },
        user_billing_status: 'active', // @TODO: update this for adyen (active/pending)
        in_member_base: !trialPeriod || isReactivation,
        payment_provider: PAYMENT_PROVIDER_NAME_ZUORA,
        uuid,
        most_recent_amt_paid_in_currency: mostRecentAmount,
        currency: currencyIso,
        paid_through_date: paidThroughDate,
        full_plan_price: fullPlanPrice,
        winback: isReactivation,
      }
      postEmailCapture({
        email, optin: emailOptIn, fields, source: '',
      })
    },
  )
    .when(isCartConfirmationPage)
}

/**
 * Watcher for checking if the user has completed checkout.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCheckoutComplete ({ after }) {
  return after(
    [
      SET_RESOLVER_DATA,
      SET_APP_BOOTSTRAP_PHASE,
      SET_USER_DATA,
      SET_AUTH_LOGIN_SUCCESS,
    ],
    async ({
      state, dispatch,
    }) => {
      const {
        user,
        auth,
      } = state
      const checkoutComplete = user.getIn(['data', 'checkout_complete'])
      const loggedIn = getAuthIsLoggedIn(auth)
      const uid = _parseInt(user.getIn(['data', 'uid']))
      const accountOwnerUid = _parseInt(user.getIn(['data', 'account_owner_uid']))
      const isPrimaryAccount = uid === accountOwnerUid

      if (loggedIn && isPrimaryAccount && !checkoutComplete) {
        dispatch(renderModal(TYPE_CART_ABANDON, {
          hideDismiss: true,
        }))
      }
    },
  )
    .when(renderCartAbandon)
}

/**
 * Watcher for determining if the user is new (not a reactivation), or winback (reactivation).
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCheckoutReactivation ({ after }) {
  return after(
    [
      SET_APP_BOOTSTRAP_PHASE,
      SET_USER_DATA,
      SET_AUTH_LOGIN_SUCCESS,
    ],
    async ({
      state, dispatch,
    }) => {
      const {
        user,
      } = state
      const checkoutComplete = user.getIn(['data', 'checkout_complete'])

      dispatch({
        type: actions.SET_CHECKOUT_REACTIVATION,
        payload: checkoutComplete,
      })
    },
  )
    .when(({ state }) => {
      const { auth, resolver } = state
      const path = resolver.getIn(['data', 'path'])
      return getAuthIsLoggedIn(auth) && !isCartConfirmation(path)
    })
}

/**
 * Set checkout polling watcher that will fetch checkout order status + data
 * @param {Object} param0 The parameters
 * @param {Function} param0.before The witness before function
 */
export function watchSetCheckoutOrderStatus ({ after } = {}) {
  return after(actions.SET_CHECKOUT_ORDER_STATUS, async ({ state, action, dispatch }) => {
    const { auth, checkout } = state
    const { payload } = action
    const { id, attempts } = payload
    const reactivation = checkout.get('reactivation')
    const checkoutId = id

    // if we have reached the limit, bail
    if (attempts >= CHECKOUT_ASYNC_MAX_ATTEMPTS) {
      return dispatch(actions.setCheckoutOrderError(CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN))
    }

    const checkoutOrderData = await getCheckoutOrderData({ checkoutId, auth })

    if (_get(checkoutOrderData, 'done')) {
      if (_get(checkoutOrderData, 'success')) {
        dispatch(
          actions.setCheckoutOrderData({ ...checkoutOrderData, isReactivation: reactivation }),
        )
      } else {
        const orderErrorCode = _get(checkoutOrderData, 'errorCode') ? _get(checkoutOrderData, 'errorCode') : CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN
        dispatch(actions.setCheckoutOrderError(orderErrorCode))
      }
    } else {
      dispatch(actions.setCheckoutOrderStatus(checkoutId, attempts + 1))
    }

    return null
  })
    .debounce(CHECKOUT_ASYNC_DELAY_MILLISECONDS)
}

/**
 * Set checkout polling watcher that will fetch checkout order status + data
 * @param {Object} param0 The parameters
 * @param {Function} param0.before The witness before function
 */
export function watchCheckoutInitiated ({ after }) {
  return after([
    SET_RESOLVER_DATA,
  ], async ({
    dispatch,
  }) => {
    dispatch(actions.setCheckoutInitiated(true))
  })
    .when(({ state }) => {
      const { resolver, checkout } = state
      const path = resolver.get('path')
      const checkoutInitiated = checkout.get('checkoutInitiated')

      if (
        (path === URL_PLAN_SELECTION
        || path === URL_PLAN_SELECTION_PLANS
        || path === URL_ACCOUNT_CREATION
        || path === URL_CART_ACCOUNT_CREATION_CREATE
        || path === URL_CART_BILLING
        || path === URL_CART_BILLING_PAYMENT)
        && !checkoutInitiated
      ) {
        return true
      }

      return false
    })
}
